import { AdapterFactory } from '../AdapterFactory';

export const complaintService = AdapterFactory.getComplaintAdapter();
